import React from "react";

interface Logo {
  src?: string;
  alt?: string;
  width?: number;
  height?: number;
  className?: string;
  isDark?: boolean;
}

const Logo: React.FC<Logo> = ({
  width = 150,
  height,
  className = "",
  isDark,
}) => {
  const src = isDark ? "/logo-dark.svg" : "/logo-light.svg";
  return (
    <img
      src={src}
      alt={"Brand Logo"}
      width={width}
      height={height}
      className={`logo-component ${className}`}
      style={{
        display: "block",
        maxWidth: "100%",
        height: height ? height : "auto",
        fill: "red",
      }}
    />
  );
};

export default Logo;
